import { useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';

import useWrappedNoundles from './useWrappedNoundles';

const useUnstakedNoundles = () => {
  const { account } = useWeb3React();
  const noundles = useWrappedNoundles();

  const [unstakedNoundles, setUnstakedNoundles] = useState([]);

  useEffect(() => {
    let ignore = false;
    setUnstakedNoundles([]);
    if (noundles) {
      const fetchNoundles = () => {
        noundles.walletOfOwner(account).then((tokenIds) => {
          if (!ignore)
            setUnstakedNoundles(tokenIds.map((tokenId) => tokenId.toNumber()));
        });
      };
      fetchNoundles();
      const transferFrom = noundles.filters.Transfer(account);
      const transferTo = noundles.filters.Transfer(null, account);
      noundles.on(transferFrom, fetchNoundles);
      noundles.on(transferTo, fetchNoundles);
      return () => {
        noundles.off(transferFrom, fetchNoundles);
        noundles.off(transferTo, fetchNoundles);
        ignore = true;
      };
    }
  }, [noundles, account]);

  return unstakedNoundles;
};

export default useUnstakedNoundles;
